export const categories = [
  {
    id: 'cat-1',
    slug: 'wanghong-tafang',
    name: '网红塌房',
    nameEn: 'Celebrity Scandals',
    description: '追踪网红明星塌房事件，第一时间爆料最新黑料，还原事件真相。',
    icon: 'ri-alert-fill',
  },
  {
    id: 'cat-2',
    slug: 'heiliao-shipin',
    name: '黑料视频',
    nameEn: 'Expose Videos',
    description: '最新黑料视频合集，高清在线观看，持续更新热门爆料内容。',
    icon: 'ri-video-fill',
  },
  {
    id: 'cat-3',
    slug: 'zhengyi-shijian',
    name: '争议事件',
    nameEn: 'Controversies',
    description: '网红争议事件深度解析，多角度还原事件来龙去脉。',
    icon: 'ri-fire-fill',
  },
  {
    id: 'cat-4',
    slug: 'chigua-baoliao',
    name: '吃瓜爆料',
    nameEn: 'Gossip & Tips',
    description: '匿名网友投稿，最新吃瓜爆料汇总，理性吃瓜不站队。',
    icon: 'ri-chat-smile-2-fill',
  },
  {
    id: 'cat-5',
    slug: 'dujia-shoufa',
    name: '独家首发',
    nameEn: 'Exclusive',
    description: '17黑料网独家首发爆料内容，全网最快最全。',
    icon: 'ri-star-fill',
  },
];

export const articles = [
  {
    id: 'article-1',
    slug: 'dingji-wanghong-beihou-zhenxiang',
    title: '顶级网红直播翻车现场：背后团队操作真相大揭秘',
    excerpt: '一场看似偶然的直播事故，背后竟牵扯出千万级网红团队的幕后操作黑幕。知情人独家爆料，还原事件全貌。',
    content: `## 事件背景

近日，一位拥有千万粉丝的头部网红在直播中意外"翻车"，镜头意外捕捉到了其背后团队的操作画面，引发了网友的广泛讨论。

## 直播翻车全过程

据现场观众描述，当晚该网红正在进行一场带货直播。直播进行到一半时，工作人员不慎走入镜头范围，手中拿着的提词器上赫然显示着精心编排的"台词脚本"，甚至连"即兴反应"都写好了剧本。

"我看了三年她的直播，一直以为是真实反应，结果全是演的。"一位忠实粉丝在评论区留言，获得了超过10万点赞。

## 团队操作内幕

知情人士向我们透露，该网红背后有一个超过30人的专业团队，包括：

- 编剧组：负责撰写直播"剧本"，设计情绪起伏节点
- 数据组：实时监控弹幕舆情，随时调整话术
- 运营组：操控直播间人气数据，制造虚假繁荣
- 水军组：引导评论风向，压制负面声音

## 网友反应

事件曝光后，话题迅速登上热搜。大量粉丝表示失望，也有部分网友表示"早就有预感"。该网红目前尚未对此事做出正面回应。

> "人设崩塌只需要一瞬间，但建立信任需要很多年。"

我们将持续关注此事的后续发展。`,
    categorySlug: 'wanghong-tafang',
    categoryName: '网红塌房',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20backstage%20of%20a%20live%20streaming%20studio%20with%20dramatic%20red%20and%20gold%20lighting%2C%20silhouette%20of%20a%20person%20behind%20camera%20equipment%2C%20cinematic%20atmosphere%20with%20film%20grain%20texture%2C%20mysterious%20and%20tense%20mood%2C%20editorial%20photography%20style%20with%20high%20contrast%2C%20dark%20background%20with%20warm%20accent%20lights&width=800&height=450&seq=article-hero-01&orientation=landscape',
    date: '2026-07-06',
    views: 128500,
    comments: 3421,
    tags: ['直播翻车', '人设崩塌', '团队操作', '网红黑料'],
    isFeatured: true,
    isHot: true,
    isExclusive: true,
    author: '17黑料网编辑部',
    readTime: 8,
  },
  {
    id: 'article-2',
    slug: 'duan-shipin-daV-bei-bao-shuiju',
    title: '知名短视频博主被曝数据造假：百万播放量竟是水军刷出来的',
    excerpt: '某平台头部短视频博主被扒出播放数据严重造假，实际观看人数不足显示的十分之一。业内人士揭露短视频数据造假产业链。',
    content: `## 数据造假的冰山一角

短视频行业的数据造假问题由来已久，但这次被曝光的规模之大令人震惊。

## 造假手段揭秘

根据技术团队的分析报告，该博主的多条视频存在以下异常：

1. 播放量在凌晨2-4点出现异常峰值，与正常用户活跃时间完全不符
2. 评论内容重复率高达67%，大量账号使用相同的评论模板
3. 点赞增长速度呈现不自然的"阶梯式"曲线

## 产业链曝光

记者调查发现，短视频数据造假已经形成了一条完整的灰色产业链。从刷量脚本开发、账号租赁到数据维护，每个环节都有专人负责。

据业内人士估算，该产业链年产值超过数十亿元。

## 平台回应

平台方表示将加强数据监测，对违规账号进行严肃处理。目前已对涉事账号进行限流处理。

我们将继续关注事件进展。`,
    categorySlug: 'zhengyi-shijian',
    categoryName: '争议事件',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dimly%20lit%20server%20room%20with%20rows%20of%20computer%20screens%20displaying%20fake%20engagement%20data%2C%20red%20warning%20indicators%20glowing%2C%20dark%20atmosphere%20with%20technological%20suspense%2C%20cinematic%20lighting%20with%20harsh%20shadows%2C%20investigative%20journalism%20aesthetic&width=800&height=450&seq=article-hero-02&orientation=landscape',
    date: '2026-07-05',
    views: 96500,
    comments: 2187,
    tags: ['数据造假', '短视频', '水军', '播放量'],
    isFeatured: false,
    isHot: true,
    isExclusive: false,
    author: '17黑料网编辑部',
    readTime: 6,
  },
  {
    id: 'article-3',
    slug: 'meishizhubo-shipin-zaojia',
    title: '美食博主视频造假实锤：精致摆拍背后竟是道具菜品',
    excerpt: '知名美食博主被扒出视频中使用道具食物拍摄，那些让人垂涎欲滴的美食全是不能吃的"模型"。',
    content: `## 美食博主的秘密

美食赛道一直是短视频平台最热门的领域之一，但精致画面背后究竟有多少真实？

## 道具食品曝光

一位前员工爆料，该美食博主团队长期使用专业食品道具进行拍摄。那些色泽诱人、摆盘精美的菜品，实际上是用树脂、塑料等材料制作的道具模型。

"真正的食物在镜头前撑不过几分钟就会变色变形，所以他们全部使用道具拍摄。"该前员工表示。

## 行业普遍现象

记者深入调查后发现，使用食品道具在美食短视频领域并非个例。多位业内人士证实，为了追求完美的视觉效果，大量美食博主都在使用各类拍摄辅助手段。

## 粉丝反应

消息传出后，大量粉丝表示被骗："原来我跟着学的菜谱，博主自己都没做过。"

该博主已发布道歉声明，承认部分视频使用了辅助拍摄手段。`,
    categorySlug: 'heiliao-shipin',
    categoryName: '黑料视频',
    imageUrl: 'https://readdy.ai/api/search-image?query=Fake%20food%20props%20on%20a%20photography%20set%2C%20plastic%20food%20models%20that%20look%20realistic%20under%20studio%20lighting%2C%20camera%20equipment%20in%20background%2C%20dark%20moody%20atmosphere%20with%20selective%20lighting%2C%20behind%20the%20scenes%20of%20content%20creation%2C%20editorial%20photography&width=800&height=450&seq=article-hero-03&orientation=landscape',
    date: '2026-07-04',
    views: 87500,
    comments: 1956,
    tags: ['美食博主', '道具造假', '视频拍摄', '行业黑幕'],
    isFeatured: false,
    isHot: true,
    isExclusive: true,
    author: '17黑料网编辑部',
    readTime: 5,
  },
  {
    id: 'article-4',
    slug: 'daihuo-yijie-bei-zhi-jiahuo',
    title: '头部带货主播被指售假：消费者联合维权要求十倍赔偿',
    excerpt: '多位消费者联合发声，指控某头部带货主播销售假冒品牌商品。市场监管部门已介入调查。',
    content: `## 消费者集体维权

一场由消费者自发组织的维权行动正在社交媒体上发酵，矛头直指某拥有数千万粉丝的头部带货主播。

## 假冒商品详情

根据消费者提供的证据，该主播直播间销售的"名牌"商品存在以下问题：

- 包装与正品存在明显差异
- 产品质量远低于品牌标准
- 防伪标识无法通过官方验证
- 品牌方确认未与该主播有过合作

## 维权进展

目前已有超过500名消费者加入维权群，涉案金额据估算超过200万元。律师团队表示，根据《消费者权益保护法》，消费者有权要求"退一赔三"，情节严重可主张"退一赔十"。

## 行业反思

事件再次引发了公众对直播带货行业监管的讨论。专家呼吁平台方加强商家资质审核，建立更完善的消费者保护机制。`,
    categorySlug: 'wanghong-tafang',
    categoryName: '网红塌房',
    imageUrl: 'https://readdy.ai/api/search-image?query=Counterfeit%20luxury%20products%20scattered%20on%20a%20dark%20table%2C%20dramatic%20lighting%20from%20above%2C%20investigative%20journalism%20style%2C%20red%20and%20black%20color%20palette%2C%20moody%20atmosphere%20with%20sharp%20shadows%2C%20consumer%20rights%20theme&width=800&height=450&seq=article-hero-04&orientation=landscape',
    date: '2026-07-03',
    views: 156200,
    comments: 5876,
    tags: ['售假', '消费者维权', '直播带货', '十倍赔偿'],
    isFeatured: true,
    isHot: true,
    isExclusive: false,
    author: '17黑料网编辑部',
    readTime: 7,
  },
  {
    id: 'article-5',
    slug: 'mou-yin-mingxing-hunwaiqing-baoguang',
    title: '某影视明星婚外情曝光：深夜密会视频流出引哗然',
    excerpt: '一段疑似某知名影视明星的深夜密会视频在社交平台疯传，引发网友对其婚姻状况的广泛猜测。',
    content: `## 视频流出

昨日深夜，一段模糊的视频开始在各大社交平台流传。视频中一对男女举止亲密，虽然画面不够清晰，但多方信息指向一位已婚影视明星。

## 网友分析

网友们迅速展开了"侦探式"分析：

1. 视频拍摄地点被锁定为某高档酒店地下车库
2. 视频中人物衣着与该明星前一天公开活动着装一致
3. 时间线与该明星公开行程存在矛盾

## 当事人回应

截至目前，该明星及其工作室均未对此事做出回应。其社交媒体账号评论区已被网友"攻陷"。

## 理性看待

在缺乏确凿证据的情况下，我们呼吁网友理性吃瓜，不传谣不信谣。真相有待进一步核实。`,
    categorySlug: 'chigua-baoliao',
    categoryName: '吃瓜爆料',
    imageUrl: 'https://readdy.ai/api/search-image?query=Blurry%20paparazzi%20style%20photograph%20at%20night%2C%20underground%20parking%20garage%20with%20dim%20yellow%20lighting%2C%20two%20silhouettes%20in%20the%20distance%2C%20grainy%20film%20texture%2C%20mysterious%20atmosphere%2C%20dark%20and%20moody%20tone%2C%20sensational%20tabloid%20style&width=800&height=450&seq=article-hero-05&orientation=landscape',
    date: '2026-07-02',
    views: 234500,
    comments: 8921,
    tags: ['明星绯闻', '婚外情', '视频流出', '娱乐圈'],
    isFeatured: false,
    isHot: true,
    isExclusive: false,
    author: '17黑料网编辑部',
    readTime: 4,
  },
  {
    id: 'article-6',
    slug: 'youxi-zhubo-kaigua-shiyong-waigua',
    title: '知名游戏主播被实锤使用外挂：直播操作与后台数据严重不符',
    excerpt: '技术团队通过逐帧分析，发现某游戏主播的直播操作存在大量异常，疑似使用高级外挂程序。',
    content: `## 技术分析

一支专业的技术分析团队对该游戏主播的直播录像进行了逐帧分析，发现了多处操作异常。

## 异常操作详解

技术报告指出了以下几个关键问题：

- 瞄准反应时间远低于人类极限
- 多次出现"穿墙"预判行为
- 鼠标移动轨迹不符合人体工学规律
- 后台数据与画面显示存在时间差

## 主播回应

该主播在直播中否认使用外挂，声称自己的操作纯属"天赋和练习"。但技术团队表示愿意公开完整分析报告供公众验证。

## 平台态度

游戏平台和直播平台均已表示将对此事进行调查。如查实使用外挂，将面临封号处理。

此事再次引发了游戏直播行业诚信问题的讨论。`,
    categorySlug: 'zhengyi-shijian',
    categoryName: '争议事件',
    imageUrl: 'https://readdy.ai/api/search-image?query=Gaming%20setup%20with%20multiple%20monitors%20in%20a%20dark%20room%2C%20red%20neon%20lighting%2C%20computer%20code%20on%20one%20screen%20and%20game%20on%20another%2C%20hacker%20aesthetic%2C%20cyberpunk%20atmosphere%2C%20mysterious%20tech%20vibe%2C%20dark%20background&width=800&height=450&seq=article-hero-06&orientation=landscape',
    date: '2026-07-01',
    views: 112300,
    comments: 4532,
    tags: ['游戏主播', '外挂', '直播造假', '技术分析'],
    isFeatured: false,
    isHot: false,
    isExclusive: true,
    author: '17黑料网编辑部',
    readTime: 5,
  },
  {
    id: 'article-7',
    slug: 'wanghong-canting-wei-sheng-baoguang',
    title: '网红餐厅后厨卫生曝光：光鲜视频背后老鼠蟑螂横行',
    excerpt: '一位自称前员工的网友爆料某网红餐厅后厨卫生状况触目惊心，与精致宣传视频形成鲜明对比。',
    content: `## 表里不一的网红餐厅

社交平台上那些让人垂涎欲滴的美食视频背后，究竟隐藏着怎样的真相？

## 前员工爆料

一位自称在该网红餐厅工作过半年的前员工，在社交平台发布了一组长图，展示了后厨的真实状况：

- 食材随意堆放在地面
- 厨房角落有老鼠活动的痕迹
- 蟑螂在操作台附近出没
- 部分过期食材仍在被使用

## 与宣传的强烈反差

该餐厅在社交平台上的宣传视频展示的是干净整洁的开放式厨房、新鲜的食材和专业的厨师团队。而现实中的后厨状况与宣传画面天差地别。

## 市场监管介入

当地市场监管部门已收到举报，表示将对该餐厅进行突击检查。涉事餐厅暂未回应。

食品安全无小事，我们将持续关注。`,
    categorySlug: 'heiliao-shipin',
    categoryName: '黑料视频',
    imageUrl: 'https://readdy.ai/api/search-image?query=Dirty%20restaurant%20kitchen%20with%20dim%20lighting%2C%20contrast%20between%20beautiful%20plated%20food%20in%20foreground%20and%20messy%20kitchen%20in%20background%2C%20dark%20moody%20atmosphere%2C%20investigative%20style%2C%20split%20composition%20showing%20facade%20vs%20reality&width=800&height=450&seq=article-hero-07&orientation=landscape',
    date: '2026-06-30',
    views: 145800,
    comments: 6543,
    tags: ['网红餐厅', '食品安全', '后厨卫生', '前员工爆料'],
    isFeatured: false,
    isHot: true,
    isExclusive: false,
    author: '17黑料网编辑部',
    readTime: 6,
  },
  {
    id: 'article-8',
    slug: 'kuaishou-zhubo-juanqian-paolu',
    title: '快手主播被指卷款跑路：粉丝打赏数百万后人间蒸发',
    excerpt: '某快手平台主播在收到粉丝巨额打赏后突然停播，所有联系方式均无法接通，疑似卷款跑路。',
    content: `## 粉丝打赏后主播消失

一场涉及数百万金额的主播消失事件正在快手平台引发轩然大波。

## 事件经过

据粉丝群内成员描述，该主播在停播前一周曾频繁以"家人生病急需用钱"、"投资周转"等理由向粉丝借款。在多笔大额转账后，该主播突然关闭了所有社交账号，电话也无法接通。

## 受害粉丝发声

"前前后后给他转了将近10万，现在人就这么消失了。我们群里加起来可能损失了几百万。"一位受害粉丝说。

目前受害者已组建维权群，统计损失金额并准备向公安机关报案。

## 平台回应

快手平台表示高度重视此事，已冻结该主播的账号余额，并将配合公安机关调查。

直播打赏需理性，粉丝切勿过度消费。`,
    categorySlug: 'wanghong-tafang',
    categoryName: '网红塌房',
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20streaming%20room%20with%20ring%20light%20turned%20off%2C%20abandoned%20equipment%2C%20dark%20atmosphere%2C%20dusty%20setup%2C%20eerie%20feeling%20of%20absence%2C%20cold%20moody%20lighting%2C%20deserted%20studio%20space%2C%20editorial%20photography&width=800&height=450&seq=article-hero-08&orientation=landscape',
    date: '2026-06-29',
    views: 189300,
    comments: 7234,
    tags: ['快手主播', '卷款跑路', '粉丝打赏', '诈骗'],
    isFeatured: true,
    isHot: true,
    isExclusive: true,
    author: '17黑料网编辑部',
    readTime: 5,
  },
  {
    id: 'article-9',
    slug: 'mingshi-wanghong-bei-zhi-taoshu',
    title: '百万粉丝颜值博主被曝偷税漏税：补缴税款超千万',
    excerpt: '税务部门公布最新案例，某百万粉丝颜值博主因偷逃税款被追缴并处以罚款，总金额超过千万。',
    content: `## 税务部门通报

国家税务总局日前公布了一起网络主播偷逃税款典型案例，涉案金额高达千万级别。

## 案件详情

经税务部门调查，该博主通过以下方式偷逃税款：

- 将个人收入伪装为企业收入
- 通过多家空壳公司分流收入
- 部分收入未依法申报纳税
- 使用虚假发票冲抵成本

## 处罚结果

税务机关依法对其追缴税款、加收滞纳金并处罚款，合计金额超过1000万元。该博主已缴清全部款项。

## 行业警示

税务部门表示，网络主播行业将面临更严格的税收监管。目前已有多地税务机关向头部主播发出自查通知。

合法纳税是每个公民的义务。`,
    categorySlug: 'zhengyi-shijian',
    categoryName: '争议事件',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stack%20of%20tax%20documents%20and%20Chinese%20currency%20on%20a%20dark%20desk%2C%20dramatic%20lighting%20from%20one%20side%2C%20official%20government%20building%20silhouette%20in%20background%2C%20serious%20mood%2C%20business%20investigation%20theme%2C%20high%20contrast%20photography&width=800&height=450&seq=article-hero-09&orientation=landscape',
    date: '2026-06-28',
    views: 201400,
    comments: 5678,
    tags: ['偷税漏税', '颜值博主', '税务稽查', '千万罚款'],
    isFeatured: false,
    isHot: true,
    isExclusive: false,
    author: '17黑料网编辑部',
    readTime: 6,
  },
  {
    id: 'article-10',
    slug: 'douyin-wanghong-sanfang-jianju',
    title: '抖音网红"三防"人设崩塌：嘴上环保私下却是污染大户',
    excerpt: '一位主打环保人设的抖音网红被邻居曝光，私下生活中存在大量不环保行为，网友直呼"双面人"。',
    content: `## 环保人设的崩塌

"人设"越是完美，崩塌时就越是难堪。

## 邻居曝光

一位自称是该网红邻居的网友在社交平台发布了多段视频，展示该网红的"另一面"：

- 家中垃圾从不分类
- 大量使用一次性塑料制品
- 私家车排量极大，油耗惊人
- 宠物粪便从不清理

这些行为与该网红在视频中倡导的"低碳环保"理念形成了巨大反差。

## 网友反应

"嘴上说着保护地球，实际生活中连垃圾分类都不做，太双标了。"网友纷纷表示失望和愤怒。

## 公关危机

该网红发布道歉声明称"将努力改进"，但网友并不买账，认为这只是危机公关手段。其粉丝数量在一周内下降了超过50万。`,
    categorySlug: 'chigua-baoliao',
    categoryName: '吃瓜爆料',
    imageUrl: 'https://readdy.ai/api/search-image?query=Split%20composition%20showing%20contrast%2C%20left%20side%20green%20eco%20friendly%20clean%20nature%2C%20right%20side%20pollution%20and%20waste%2C%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%2C%20hypocrisy%20theme%2C%20editorial%20style%20photography&width=800&height=450&seq=article-hero-10&orientation=landscape',
    date: '2026-06-27',
    views: 167200,
    comments: 8765,
    tags: ['人设崩塌', '环保网红', '双面人', '抖音'],
    isFeatured: false,
    isHot: false,
    isExclusive: false,
    author: '17黑料网编辑部',
    readTime: 5,
  },
  {
    id: 'article-11',
    slug: 'xiao-hong-shu-bozhu-guanggao-xu-jia',
    title: '小红书博主广告虚假宣传被罚：宣称"三天美白"实为P图效果',
    excerpt: '某小红书美妆博主因广告中虚假宣传被市场监管部门处罚，其宣传的"三天美白"效果全靠后期修图。',
    content: `## 虚假广告的代价

一张精修图片配上夸张的功效描述，似乎成了部分美妆博主的流量密码。

## 被罚案例

市场监管部门公布的案例显示，某小红书博主在其推广的美白产品广告中使用了经过严重后期处理的对比图，并声称"使用三天见效"。

实际情况是，该博主从未真正使用过该产品，所有效果图均为修图软件处理。

## 处罚结果

根据《广告法》相关规定，该博主被处以20万元罚款，并要求公开道歉。相关品牌方也被追究了连带责任。

## 行业整治

市场监管部门表示，将持续加强对社交平台广告内容的监管力度，特别是美妆、保健品等容易出现虚假宣传的领域。`,
    categorySlug: 'zhengyi-shijian',
    categoryName: '争议事件',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beauty%20product%20photography%20setup%20with%20ring%20light%20and%20camera%2C%20before%20and%20after%20photoshop%20comparison%20on%20computer%20screen%2C%20dark%20studio%20atmosphere%2C%20deceptive%20marketing%20theme%2C%20professional%20lighting%20setup%2C%20editorial%20style&width=800&height=450&seq=article-hero-11&orientation=landscape',
    date: '2026-06-26',
    views: 98700,
    comments: 3214,
    tags: ['虚假宣传', '小红书', '美妆博主', '广告法'],
    isFeatured: false,
    isHot: false,
    isExclusive: false,
    author: '17黑料网编辑部',
    readTime: 5,
  },
  {
    id: 'article-12',
    slug: 'bilibili-upzhu-chao-xi-men',
    title: 'B站UP主被指抄袭外网内容：直接搬运翻译冒充原创',
    excerpt: '多位B站知名UP主被网友扒出视频内容大量抄袭YouTube创作者，简单翻译后标注原创发布。',
    content: `## 搬运还是原创？

B站作为国内最大的视频弹幕网站，其创作者生态一直备受关注。但近期多位UP主被曝出"搬运"争议。

## 指控详情

网友通过视频对比发现，多位知名UP主的内容与YouTube上的视频高度相似：

- 视频结构完全一致
- 文案几乎是对英文原文的直译
- 没有标注任何参考来源
- 在简介中声明为"原创内容"

## UP主回应

部分被点名的UP主已发布道歉声明，承认"参考"了外网内容但否认抄袭。然而网友们并不认可这一说法。

## 版权意识

这一系列事件引发了关于内容创作者版权意识的讨论。B站官方表示将加强对原创内容的审核和保护力度。`,
    categorySlug: 'heiliao-shipin',
    categoryName: '黑料视频',
    imageUrl: 'https://readdy.ai/api/search-image?query=Video%20editing%20timeline%20on%20computer%20screen%20with%20side%20by%20side%20comparison%20of%20two%20videos%2C%20dark%20room%20with%20monitor%20glow%2C%20plagiarism%20detection%20theme%2C%20moody%20atmosphere%2C%20content%20creation%20setup%2C%20editorial%20photography&width=800&height=450&seq=article-hero-12&orientation=landscape',
    date: '2026-06-25',
    views: 135600,
    comments: 4567,
    tags: ['B站', '抄袭', '搬运', '原创争议'],
    isFeatured: false,
    isHot: false,
    isExclusive: true,
    author: '17黑料网编辑部',
    readTime: 4,
  },
];

export const faqs = [
  {
    question: '17黑料网是什么网站？',
    answer: '17黑料网是一个专注于网红黑料、吃瓜爆料和争议事件追踪的中文娱乐资讯平台。我们每日更新最新黑料视频、网红塌房事件、争议话题等内容，为网友提供全面的吃瓜资讯。',
  },
  {
    question: '17黑料网的内容来源是什么？',
    answer: '17黑料网的内容来源于公开网络信息整理、网友投稿以及编辑团队原创采编。所有内容均标注来源，仅供参考娱乐。如有不实信息，欢迎联系我们进行核实更正。',
  },
  {
    question: '如何在17黑料网投稿爆料？',
    answer: '您可以通过网站底部的"联系我们"邮箱发送爆料信息。我们承诺严格保护爆料人隐私，所有投稿均采用匿名处理。请注意，爆料内容需附上相关证据以提高可信度。',
  },
  {
    question: '17黑料网的内容是否属实？',
    answer: '我们努力确保所有发布内容的真实性和准确性，但部分信息来源于网络，可能存在偏差。我们建议读者理性看待，多方求证。如发现不实内容，请及时联系我们处理。',
  },
  {
    question: '17黑料网如何保护用户隐私？',
    answer: '我们高度重视用户隐私保护。所有用户投稿信息均采用加密存储，不向任何第三方透露投稿人身份信息。网站浏览不会收集个人身份信息。',
  },
];

export const testimonials = [
  {
    id: 'testimonial-1',
    name: '吃瓜群众小王',
    username: '@xiaowang_chigua',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20orange%20gradient%20background%2C%20geometric%20simple%20design%2C%20modern%20flat%20illustration%20style%2C%20clean%20and%20professional&width=120&height=120&seq=avatar-test-01&orientation=squarish',
    comment: '17黑料网真的是我的每日必刷，更新速度太快了！每次有网红翻车，这里总是第一个出详细解析的，比微博热搜还快。',
  },
  {
    id: 'testimonial-2',
    name: '娱乐圈观察员',
    username: '@yule_observer',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20teal%20gradient%20background%2C%20simple%20geometric%20shapes%2C%20modern%20flat%20design%2C%20clean%20aesthetic%2C%20professional%20style&width=120&height=120&seq=avatar-test-02&orientation=squarish',
    comment: '作为一个做了五年娱乐圈观察的人，17黑料网的深度分析确实到位。不是简单的转载，每篇文章都有自己的观点和调查。',
  },
  {
    id: 'testimonial-3',
    name: '正义路人甲',
    username: '@zhengyi_luren',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20coral%20pink%20gradient%20background%2C%20simple%20geometric%20circle%20design%2C%20modern%20flat%20illustration%2C%20clean%20and%20friendly&width=120&height=120&seq=avatar-test-03&orientation=squarish',
    comment: '之前在一个网红塌房事件中，我提供了重要线索给17黑料网，他们不仅认真核实，还保护了我的隐私。靠谱的平台！',
  },
  {
    id: 'testimonial-4',
    name: '深夜吃瓜人',
    username: '@midnight_melon',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20purple%20gradient%20background%2C%20geometric%20triangle%20pattern%2C%20modern%20flat%20design%2C%20clean%20aesthetic&width=120&height=120&seq=avatar-test-04&orientation=squarish',
    comment: '每天晚上睡前必刷17黑料网，已经成了习惯了。内容的深度和质量在同类型网站里绝对是第一梯队的。',
  },
  {
    id: 'testimonial-5',
    name: '理性吃瓜者',
    username: '@lixing_chigua',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20green%20gradient%20background%2C%20simple%20geometric%20design%2C%20modern%20flat%20illustration%2C%20clean%20professional%20style&width=120&height=120&seq=avatar-test-05&orientation=squarish',
    comment: '最欣赏17黑料网的一点是它不偏激，每篇文章都会列出多方说法，让读者自己判断。这种态度在同类型网站里很少见。',
  },
  {
    id: 'testimonial-6',
    name: '八卦达人小美',
    username: '@bagua_daren',
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20avatar%20with%20warm%20yellow%20gradient%20background%2C%20simple%20circle%20and%20line%20design%2C%20modern%20flat%20illustration%2C%20clean%20aesthetic&width=120&height=120&seq=avatar-test-06&orientation=squarish',
    comment: '从知乎看到一个爆料链接过来的，然后就停不下来了！这里的内容比那些只有标题党的网站强太多了，每篇都是干货。',
  },
];

export const siteInfo = {
  name: '17黑料网',
  tagline: '全网独家吃瓜追踪',
  description: '17黑料网是领先的网红黑料追踪与吃瓜资讯平台，每日更新最新网红塌房事件、黑料视频、争议热点。我们致力于为网友提供真实、全面、及时的娱乐资讯内容。',
  foundedYear: 2020,
  stats: {
    operatingDays: 2000,
    totalArticles: 50000,
    dailyVisitors: 1000000,
    accuracy: 99,
  },
  contact: {
    email: 'hello@yiyaxiang.cn',
    wechat: '17heiliaowang',
    weibo: '@17黑料网官方',
    reportEmail: 'hello@yiyaxiang.cn',
  },
};